var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 2.66663C4.66667 1.56206 5.5621 0.666626 6.66667 0.666626H9.33333C10.4379 0.666626 11.3333 1.56206 11.3333 2.66663V2.99996C12.4379 2.99996 13.3333 3.89539 13.3333 4.99996V5.99996H14C15.1046 5.99996 16 6.89539 16 7.99996V13.3333C16 14.4379 15.1046 15.3333 14 15.3333H2C0.89543 15.3333 0 14.4379 0 13.3333V7.99996C0 6.89539 0.895431 5.99996 2 5.99996H2.66667V4.99996C2.66667 3.89539 3.5621 2.99996 4.66667 2.99996V2.66663ZM6 2.99996H10V2.66663C10 2.29844 9.70152 1.99996 9.33333 1.99996H6.66667C6.29848 1.99996 6 2.29844 6 2.66663V2.99996ZM4 5.99996H12V4.99996C12 4.63177 11.7015 4.33329 11.3333 4.33329H4.66667C4.29848 4.33329 4 4.63177 4 4.99996V5.99996ZM2 7.33329C1.63181 7.33329 1.33333 7.63177 1.33333 7.99996V13.3333C1.33333 13.7015 1.63181 14 2 14H14C14.3682 14 14.6667 13.7015 14.6667 13.3333V7.99996C14.6667 7.63177 14.3682 7.33329 14 7.33329H2Z",
    fill: "#EFF3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.e911f428f574d99331526bc21507e276.svg";
export { ForwardRef as ReactComponent };